import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { EnrollmentAddService } from "src/app/services/enrollment-add.service";
import { EnrollmentBuyupService } from "src/app/services/enrollment-buyup.service";
import { CoverageTab } from "src/app/models/coverage";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { MaskType } from "src/app/constants/masks";
import { debounceTime } from "rxjs";
import { MaskService } from "src/app/services/mask.service";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { HelperService } from "src/app/services/helper.service";
import { HSAContributionPayload, HsaPeroidContribution } from "src/app/models/hsa";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-coverage-hsa',
    templateUrl: './hsa.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HSACoverageComponent implements OnInit {
    @Input() coverageFormGroup: FormGroup;
    @Input() coverageTab: CoverageTab;

    public maskType = MaskType;
    public hsaContributionName: string = 'hsaContribution';
    public isValidName: string = 'isValidName';
    public isValid: boolean;
    public isAnnualContributionValid: boolean = true;
    public hsaPeroidContribution: HsaPeroidContribution;

    constructor(
        private maskService: MaskService,
        private helperService: HelperService,
        private enrollmentManagerService: EnrollmentManagerService,
        private enrollmentAddService: EnrollmentAddService,
        private enrollmentBuyupService: EnrollmentBuyupService,
    ) {
    }

    ngOnInit(): void {
        this.coverageFormGroup.get(this.hsaContributionName).setValue(null);
        this.coverageFormGroup.get(this.hsaContributionName).setValidators(Validators.compose([Validators.required, FormValidationService.validCurrency()]));
        this.coverageFormGroup.addControl(this.isValidName, new FormControl(this.isValid, Validators.requiredTrue));

        this.hsaPeroidContribution = this.helperService.convertObjectIntoObject(this.coverageTab, new HsaPeroidContribution());

        this.coverageFormGroup.get(this.hsaContributionName).valueChanges.pipe(debounceTime(700)).subscribe((val: string) => {
            let l_Contribution = this.maskService.removeCurrencyMask(val);

            if (!val) {
                this.setPageValidation(false);
                this.coverageTab.hsaContributionYearTotalEstimated = 0;
            } else {
                this.hsaPeroidContribution.payPeriodContribution = l_Contribution;

                if (l_Contribution > this.coverageTab.hsaContributionMaxRemaining) {
                    this.setPageValidation(false);
                    this.isAnnualContributionValid = false;
                    this.hsaPeroidContribution.hsaDisplayReductionMessage = null;
                } else {
                    const l_HSAContributionPayload: HSAContributionPayload = { payPeriodContribution: l_Contribution };
                    switch (this.enrollmentManagerService.benefitWizardControlPanel.wizardType) {
                        case BenefitWizardType.Add:
                            this.enrollmentAddService.getHsaContribution(l_HSAContributionPayload).subscribe((response: HsaPeroidContribution) => {
                                this.hsaPeroidContribution = response;
                                this.isAnnualContributionValid = true;
                                this.coverageTab.hsaContributionYearTotalEstimated = response.hsaContributionYearTotalEstimated;
                                this.setPageValidation(true);
                            });
                            break;

                        case BenefitWizardType.BuyUp:
                            this.enrollmentBuyupService.getHsaContribution(l_HSAContributionPayload).subscribe((response: HsaPeroidContribution) => {
                                this.hsaPeroidContribution = response;
                                this.isAnnualContributionValid = true;
                                this.coverageTab.hsaContributionYearTotalEstimated = response.hsaContributionYearTotalEstimated;
                                this.setPageValidation(true);
                            });
                            break;
                    }
                }


            }
        });
    }

    private setPageValidation(valid: boolean): void {
        this.coverageFormGroup.get(this.isValidName).setValue(valid);
        this.coverageFormGroup.get(this.isValidName).updateValueAndValidity();
    }
}